import {
  createBaseThemeOptions,
  palettes,
  createUnifiedTheme,
  UnifiedThemeOptions,
} from '@backstage/theme';

import HeeboFont from '../assets/fonts/Heebo/Heebo-VariableFont_wght.ttf';

const heeboFont = {
  fontFamily: 'Heebo',
  src: `
    local('Heebo'),
    url(${HeeboFont}) format('woff2'),
  `,
};

const themeOptions = {
  light: {
    buttonBackgroundColor: '#00D6E3',
    buttonTextColor: '#000000',
    linkColor: '#008A8D',
  },
  primaryColor: '#000000',
  headerColor: '#FFFFFF',
};

const commonConfiguration: Omit<UnifiedThemeOptions, 'palette'> = {
  defaultPageTheme: 'home',
  fontFamily: 'Heebo',
};

const commonComponents = {
  MuiCssBaseline: {
    styleOverrides: {
      '@font-face': [heeboFont],
    },
  },
  BackstageSidebarItem: {
    styleOverrides: {
      root: {
        textDecoration: 'none',
      },
    },
  },
  BackstageSelect: {
    styleOverrides: {
      root: {
        maxWidth: 300,
      },
    },
  },
};

export const BackstageLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: themeOptions.primaryColor,
      },
    },
  }),
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: {
          color: themeOptions.headerColor,
        },
        title: {
          color: themeOptions.headerColor,
        },
        subtitle: {
          color: themeOptions.headerColor,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: `${themeOptions.light.buttonBackgroundColor} !important`,
          color: `${themeOptions.light.buttonTextColor} !important`,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: `${themeOptions.light.linkColor} !important`,
        },
      },
    },
    ...commonComponents,
  },
  ...commonConfiguration,
});

export const BackstageDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
    },
  }),
  components: {
    ...commonComponents,
  },
  ...commonConfiguration,
});
